import { render, staticRenderFns } from "./DVideoUploadEditor.vue?vue&type=template&id=c0f17dfa&"
import script from "./DVideoUploadEditor.vue?vue&type=script&lang=js&"
export * from "./DVideoUploadEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports